import { storage, usersCollection } from "../../config/firebase";

let state = {
  socialCredits: [],
  loading: false,
  notification: { message: "", type: "" },
};
let getters = {
  socialCredits: (state) => state.socialCredits,
  socialCreditLoading: (state) => state.loading,
  socialCreditNotification: (state) => state.notification,
};
let actions = {
  async getSocialCredits({ commit }, payload) {
    commit("setSocialCreditLoading", true);
    usersCollection.doc(payload).onSnapshot(async (snapshot) => {
      let { social_credits } = snapshot.data();
      console.log(social_credits);
      social_credits = social_credits ? social_credits : [];
      commit("setSocialCreditsData", social_credits);
      commit("setSocialCreditLoading", false);
    });
  },
  async addSocialCredit({ commit }, payload) {
    commit("setSocialCreditLoading", true);
    let id = payload.id;
    console.log(id);
    delete payload.id;
    try {
      await usersCollection
        .doc(id)
        .get()
        .then(async (snapshot) => {
          let data = snapshot.data();
          let { social_credits } = data;
          social_credits = social_credits ? social_credits : [];
          let obj = {
            url: payload.url,
            credits: payload.credits,
          };
          social_credits.push(obj);
          data["social_credits"] = social_credits;
          console.log("Data:", data);
          await usersCollection.doc(id).update({ ...data });
        });
    } catch (err) {
      commit("setSocialCreditsNotification", {
        message: err.message,
        type: "error",
      });
    } finally {
      commit("setSocialCreditLoading", false);
    }
  },
  async editSocialCredit({ commit }, payload) {
    commit("setSocialCreditLoading", true);
    let id = payload.id;
    delete payload.id;
    try {
      usersCollection
        .doc(id)
        .get()
        .then(async (snapshot) => {
          let { idx } = payload;
          delete payload.idx;
          let data = snapshot.data();
          let { social_credits } = data;
          let obj = {
            url: payload.url,
            credits: payload.credits,
          };
          social_credits[idx] = { ...obj };
          data["social_credits"] = social_credits;
          await usersCollection.doc(id).update({ ...data });
        });
      commit("setSocialCreditsNotification", {
        message: "Streaming Links Updated",
        type: "success",
      });
    } catch (err) {
      commit("setSocialCreditsNotification", {
        message: err.message,
        type: "error",
      });
    } finally {
      commit("setSocialCreditLoading", false);
    }
  },
  async deleteSocialCredit({ commit }, payload) {
    commit("setSocialCreditLoading", true);
    let id = payload.id;
    delete payload.id;
    try {
      usersCollection
        .doc(id)
        .get()
        .then(async (snapshot) => {
          let idx = payload.idx;
          delete payload.idx;
          let data = snapshot.data();
          let { social_credits } = data;
          social_credits = social_credits.filter((_, index) => idx != index);
          data["social_credits"] = social_credits;
          await usersCollection.doc(id).update({ ...data });
        });
      commit("setSocialCreditsNotification", {
        message: "Streaming Links Deleted",
        type: "success",
      });
    } catch (err) {
      commit("setSocialCreditsNotification", {
        message: err.message,
        type: "error",
      });
    } finally {
      commit("setSocialCreditLoading", false);
    }
  },
};
let mutations = {
  setSocialCreditsData(state, payload) {
    state.socialCredits = payload;
  },
  setSocialCreditLoading(state, payload) {
    state.loading = payload;
  },
  setSocialCreditsNotification(state, payload) {
    let { notification } = state;
    notification.message = payload.message;
    notification.type = payload.type;
    state.notification = notification;
    window.setTimeout(() => {
      let obj = { message: "", type: "" };
      state.notification = obj;
    }, 5000);
  },
};
export default { state, getters, actions, mutations };
